export default __webpack_public_path__ + "static/media/logo.fb8b7d87.png";